import { Popover } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useId, useState } from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { FaEquals } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';

const SimilarArticlesCell = ({ name, similarArticles, markedDuplicateCode, onMarkDuplicate }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const id = useId();
  const open = Boolean(anchorEl);
  const articles = similarArticles ?? [];

  const someMarked = articles.some((a) => a.code === markedDuplicateCode);

  const greatSimilarity = articles.some((a) => a.similarityPct >= 69);

  if (articles.length === 0) {
    return (
      <td>
        <div>
          <i>sin similares</i>
        </div>
      </td>
    );
  }

  return (
    <td>
      <style>{`@keyframes similar-blink { 0%,100%{opacity:1} 50%{opacity:0.2} }`}</style>
      <div>
        <button
          type="button"
          className="similar-articles-toggle"
          aria-owns={open ? `similar-articles-popover-${id}` : undefined}
          aria-haspopup="true"
          onClick={(event) => setAnchorEl(open ? null : event.currentTarget)}
        >
          {someMarked ? (
            <div
              style={{
                display: 'grid',
              }}
            >
              <strong>Este elemento ya existe</strong>
              <span className="text-muted">{markedDuplicateCode}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                <span className="text-muted">
                  + {articles.length - 1} similar{articles.length !== 1 ? 'es' : ''}
                </span>
                {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
              </div>
            </div>
          ) : (
            <>
              <strong>
                {articles.length} similar{articles.length !== 1 ? 'es' : ''}
              </strong>
              {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}

              {greatSimilarity && (
                <div
                  data-tooltip-id={`similar-tooltip-${id}`}
                  data-tooltip-content="Alta similitud — puede ser duplicado. Haz clic para revisar."
                  style={{
                    width: '3rem',
                    minWidth: '3rem',
                    maxWidth: '3rem',
                    cursor: 'pointer',
                    backgroundColor: '#c020204c',
                    padding: '0.2rem',
                    borderRadius: '4px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontStyle: 'italic',
                    color: '#c50202',
                  }}
                >
                  <FaEquals
                    style={{
                      color: '#c50202',
                      width: '1rem',
                      height: '1rem',
                      minWidth: '1rem',
                      maxWidth: '1rem',
                      aspectRatio: '1',
                      animation: 'similar-blink 1s ease-in-out infinite',
                    }}
                  />
                  <ReportProblemOutlinedIcon
                    style={{
                      color: '#c50202',
                      width: '1rem',
                      height: '1rem',
                      minWidth: '1rem',
                      maxWidth: '1rem',
                      aspectRatio: '1',
                      animation: 'similar-blink 1s ease-in-out infinite',
                    }}
                  />
                </div>
              )}
            </>
          )}
        </button>
        <Tooltip id={`similar-tooltip-${id}`} place="top" />
        <Popover
          id={`similar-articles-popover-${id}`}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          onClose={() => setAnchorEl(null)}
        >
          <div className="similar-articles-popover">
            <p
              style={{
                backgroundColor: '#b4c0ca',
                padding: '0.5rem',
                margin: '-0.7rem -0.7rem 1rem -0.7rem',
              }}
            >
              Articulos similares
              <br />
              <span className="text-muted">"{name}"</span>
            </p>

            {articles.map((article) => {
              const isMarked = article.code && article.code === markedDuplicateCode;
              return (
                <div
                  className={`similar-articles-popover__item${isMarked ? ' is-marked-duplicate' : ''}`}
                  key={article._id || article.code || article.name}
                >
                  <img src={article.imglink} alt={article.name} />
                  <strong>{article.code || 'Sin codigo'}</strong>
                  <span>{article.name}</span>
                  <span style={{ color: '#666', fontSize: '0.75rem' }}>{article.similarityPct ?? '?'}%</span>
                  <button
                    type="button"
                    className={`mark-duplicate-btn${isMarked ? ' marked' : ''}`}
                    onClick={() => onMarkDuplicate?.(article.code)}
                    title={isMarked ? 'Desmarcar como duplicado' : 'Marcar como duplicado'}
                  >
                    {isMarked ? '✓ Es este' : 'Es este'}
                  </button>
                </div>
              );
            })}
          </div>
        </Popover>
      </div>
    </td>
  );
};

export default SimilarArticlesCell;
